<template>
    <div id="app">
      <QairnComponent :jsonCode="jsonCode" />
    </div>
</template>

<script>
  import ElementUI from 'element-ui'
  import lang from 'element-ui/lib/locale/lang/fr'
  import locale from 'element-ui/lib/locale'
  import QairnComponent from './components/QairnComponent.vue';

  locale.use(lang)

  export default {
    name: 'app',
    components: {
    ElementUI,
    locale,
    QairnComponent
},
    data: function () {
      return {
        CompanyLogoEncodedPNGString: '',
        BackgroundPictureEncodedPNGString: '',
        FontColor: '',
        BackColor: '',
        ImageTop: false,
        BackgroundSelectedPicture: '6',
        jsonCode: {
          CompanyLogoEncodedPNGString: '',
          BackgroundPictureEncodedPNGString: '',
          FontColor: '#FFFFFF',
          BackColor: '#12313A',
          ImageTop: false,
          BackgroundSelectedPicture: '6'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue